import { render, staticRenderFns } from "./SchoolConnection.vue?vue&type=template&id=5c041338&scoped=true&lang=pug&"
var script = {}
import style0 from "./SchoolConnection.vue?vue&type=style&index=0&id=5c041338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c041338",
  null
  
)

export default component.exports